import { lazy } from 'react';

/** Loaded on first visit: the page and its samples are not part of the panel's main chunk. */
export const DevelopersPage = lazy(() => import('./DevelopersPage'));
